import React from "react";
import { SVG } from '../../types/svg.ts'
import styled from "styled-components";

export default ({
	height,
	width,
	style,
	className,
	fill,
}: SVG) => {

	return (
		<svg
			viewBox="0 0 20 10"
			className={className}
			height={height}
			width={width}
			style={style}
			fill={fill}
		>
			<Path d="M14.84 0l-1.08 1.06 3.3 3.2H0v1.49h17.05l-3.3 3.2L14.84 10 20 5l-5.16-5z"></Path>
		</svg>
	);
}

const Path = styled.path`
	transform: rotate3d(0, 1, 0, 180deg);
	transform-origin: center center;
`
